var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42.18,
    height: 34.841,
    viewBox: "0 0 42.18 34.841",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "direct",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logoservice"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1204",
    "data-name": "Pfad 1204",
    d: "M350.151,795.914H337.622a3.122,3.122,0,0,1-3.067-3.167V781.021l-.033.021a2.96,2.96,0,0,1-2.324.314,3.06,3.06,0,0,1-1.863-1.475l-2.016-3.6a3.225,3.225,0,0,1,1.123-4.323l5.928-3.532a3.5,3.5,0,0,1,1.817-.51h2.13a1.157,1.157,0,0,1,1.039.664,3.895,3.895,0,0,0,7.062,0,1.158,1.158,0,0,1,1.039-.664h2.127a3.515,3.515,0,0,1,1.9.559l5.894,3.512a3.134,3.134,0,0,1,1.429,1.922,3.235,3.235,0,0,1-.307,2.4l-2.016,3.6a3.02,3.02,0,0,1-4.191,1.157l-.071-.045v11.724A3.123,3.123,0,0,1,350.151,795.914Zm-14.435-18.16a1.134,1.134,0,0,1,.582.162,1.207,1.207,0,0,1,.58,1.038v13.793a.757.757,0,0,0,.743.77h12.529a.758.758,0,0,0,.743-.77V778.954a1.208,1.208,0,0,1,.579-1.038,1.125,1.125,0,0,1,1.16,0l1.815,1.075a.735.735,0,0,0,1.021-.279l2.014-3.6a.786.786,0,0,0,.074-.584.763.763,0,0,0-.346-.467l-5.925-3.53a1.282,1.282,0,0,0-.7-.217h-1.457a6.168,6.168,0,0,1-10.48,0h-1.46a1.227,1.227,0,0,0-.648.181l-5.935,3.539a.786.786,0,0,0-.272,1.052l2.016,3.6a.743.743,0,0,0,.452.357.713.713,0,0,0,.565-.075l1.776-1.05A1.116,1.116,0,0,1,335.716,777.754Z",
    transform: "translate(-327.909 -767.914)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1205",
    "data-name": "Pfad 1205",
    d: "M343.832,782.166h-5.448a.918.918,0,0,1-.9-.933v-5.619a.919.919,0,0,1,.9-.934h5.448a.919.919,0,0,1,.9.934v5.619A.919.919,0,0,1,343.832,782.166Zm-4.545-1.864h3.64v-3.757h-3.64Z",
    transform: "translate(-325.129 -765.672)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1206",
    "data-name": "Pfad 1206",
    d: "M343.832,784.029h-5.448a.932.932,0,0,1,0-1.862h5.448a.932.932,0,0,1,0,1.862Z",
    transform: "translate(-325.129 -763.193)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1944",
    "data-name": "Gruppe 1944",
    transform: "translate(31.277 10.39) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1570",
    "data-name": "Pfad 1570",
    d: "M0,5.252S2.315,0,7.449,0",
    transform: "translate(0 4.366)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pfad_1568",
    "data-name": "Pfad 1568",
    transform: "translate(3.787)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.510420322418213 20.24996566772461 C 3.415505886077881 20.22366142272949 3.202301025390625 19.99982070922852 3.056795120239258 19.75404357910156 C 2.082312107086182 13.67621517181396 0.6785958409309387 4.302986145019531 0.7520610690116882 3.04367995262146 C 0.8320910930633545 1.671759963035583 1.937741041183472 0.75 3.503331184387207 0.75 C 4.251461029052734 0.75 4.942760944366455 0.992110013961792 5.449911117553711 1.431730031967163 C 5.932600975036621 1.850139975547791 6.218380928039551 2.42261004447937 6.254601001739502 3.043669939041138 C 6.323601245880127 4.22652006149292 4.901801109313965 13.76173973083496 3.929291009902954 19.88231086730957 L 3.920001029968262 19.9407901763916 L 3.920001029968262 20 C 3.920001029968262 20.11958122253418 3.755736589431763 20.24753952026367 3.510420322418213 20.24996566772461 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.503331184387207 1.5 C 2.580000877380371 1.5 1.569061279296875 1.916999816894531 1.500781059265137 3.087350845336914 C 1.446534156799316 4.029518127441406 2.4298095703125 10.96424007415771 3.501644611358643 17.77402877807617 C 4.447460174560547 11.70142650604248 5.553123474121094 4.086565017700195 5.505881309509277 3.087350845336914 C 5.452230930328369 2.167579650878906 4.610031127929688 1.5 3.503331184387207 1.5 M 3.503331184387207 0 C 5.436330795288086 0 6.904561042785645 1.306690216064453 7.003331184387207 3 C 7.102110862731934 4.693309783935547 4.670001029968262 20 4.670001029968262 20 C 4.670001029968262 20.54533958435059 4.173391342163086 21 3.503331184387207 21 C 2.833271026611328 21 2.336660861968994 20 2.336660861968994 20 C 2.336660861968994 20 -0.1022686958312988 4.810279846191406 0.003331184387207031 3 C 0.1089310646057129 1.189720153808594 1.57033109664917 0 3.503331184387207 0 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rechteck_1187",
    "data-name": "Rechteck 1187",
    transform: "translate(6.79 3)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill",
    width: 1,
    height: 3,
    rx: 0.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1h1M1,0v3M1,2h-1M0,3v-3",
    fill: "none",
    clipPath: "url(#clip)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1569",
    "data-name": "Pfad 1569",
    d: "M0,0C5.135,0,9.438,8.356,6.588,9.958s-3.947-3.1-1.13-4.9a3.576,3.576,0,0,1,4.793.655",
    transform: "translate(7.796 4.433)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirect);
export default __webpack_public_path__ + "static/media/direct.7b439e1befc9a55d67b1f603a04a933b.svg";
export { ForwardRef as ReactComponent };